import React from "react"

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import { useTranslation } from 'react-i18next';

import {msToTime} from 'utils/helperFunctions'
import useStore from 'store/store'
import './FlightHeader.scss'

export default function FlightHeader({flightRecord, prevArrivalDate, headerImg}){

  const {t} = useTranslation();
  const selfCheckinMode = useStore((state)=> state.selfCheckinMode);
  let diffTime = Math.abs(new Date(flightRecord.departure_at) - new Date(prevArrivalDate));
  diffTime = msToTime(diffTime);
  return (
    <>
      {flightRecord.layover && <Box className="fh-layover">{t("Layover: "+diffTime)}</Box>}

      <Box  className={`fh-container ${!flightRecord.layover? 'top-radius': '' }  ${selfCheckinMode ? "less-padds" :  ""}`}>
        <Grid container>
          <Grid item xs={6} className="d-f ai-c ">
            <img src={headerImg || require(`assets/images/airlines/${flightRecord.airline.name.toLowerCase()}.png`)} alt="" height={selfCheckinMode? 42 : 29} />
          </Grid>
          <Grid item xs={6} container>
            <Grid item xs={12} className="r-txt black-color-opac para4 font-1-light-bt">
              {t("Flight")}
            </Grid>
            <Grid item xs={12} className={`r-txt primary1-color font-1-heavy  ${selfCheckinMode? "h6" : "para3"} `}>
              {flightRecord.flight_number}
            </Grid>
          </Grid>
        </Grid>
    
      </Box>

    </>
    )
}